<template>
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                class="date-picker-menu"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate"
                    label="Seleccione fecha de la cita"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="internalDate" @input="updateDate"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
  </template>
  
  <script>
  export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      menu: false,
      internalDate: this.value,
    };
  },
  computed: {
    formattedDate() {
      return this.internalDate ? new Date(this.internalDate).toLocaleDateString() : '';
    },
  },
  watch: {
    value(newValue) {
      this.internalDate = newValue;
    },
    internalDate(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    updateDate() {
      this.menu = false;
      this.$emit('input', this.internalDate);
    },
  },
};
</script>
  
  <style scoped>
  .date-picker-menu .v-menu__content {
    margin-bottom: 0;
  }
  </style>
  